import { call, put, select } from 'redux-saga/effects';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { authorizedLoginFailed, authorizedLogoutSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';
import { getRefreshToken } from '../../../utils/redux';
import { buildLogoutPayload } from '../authSession';

export default function* authorizedLogout(action) {
  try {
    const url = `${BACKEND_URL}/auth/logout`;
    const refresh = yield select(getRefreshToken);
    const pool = buildLogoutPayload(refresh);
    const response = yield makeRequest(url, pool, action, 'POST');

    if (window.updateTimers && window.updateTimers.length) {
      for (let i = 0, len = window.updateTimers.length; i < len; i++) {
        clearTimeout(window.updateTimers[i]);
      }
    }

    if (response.status === OK) {
      yield put(authorizedLogoutSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const responseJson = yield response.json();
      yield put(authorizedLoginFailed());
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(authorizedLoginFailed());
    yield processError(e);
  }
}
